import { actionCreators, asyncAction } from 'lib/actionCreators'

export const resume = asyncAction('RESUME')
export const addResume = asyncAction('ADD_RESUME')
export const removeResume = asyncAction('REMOVE_RESUME')
export const addResumeProgress = actionCreators('ADD_RESUME_PROGRESS')
